import script from "./AssessmentStaffDistribution.vue.vue?vue&type=script&setup=true&lang=js"
export * from "./AssessmentStaffDistribution.vue.vue?vue&type=script&setup=true&lang=js"

import "./AssessmentStaffDistribution.vue.vue?vue&type=style&index=0&id=6c3caff9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c3caff9"]])

export default __exports__